// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vuejs-progress-bar[data-v-1c5cf8e4]{display:inline-block;-ms-flex-line-pack:stretch;align-content:stretch;width:0;line-height:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
